export default {
  getEventSettings: "/event/lucky-wheel/settings",
  getEventLuckyWheel: "/event/lucky-wheel/event",
  getEventStores: "/event/lucky-wheel/stores",
  getEventLuckyWheelSummary: "/event/lucky-wheel/:id/summary",
  getLuckyWheelPrizes: "/event/lucky-wheel/:id/prizes",
  getLuckyWheelGifts: "/event/lucky-wheel/:id/gifts",
  postSpinLuckyWheel: "/event/lucky-wheel/:id/spin",
  postEventValidateOrder: "/event/lucky-wheel/:id/validate",
  category: "v1/public/category-web/",
  product_category: "v2/public/category/product/",
  category_options: "v1/public/category-options/",
  menu_categories: "v1/public/headers",
  banner: "v2/public/banner/",
  section: "v1/public/section/",
  sections: "v1/public/sections/",
  banner_category: "v1/public/banner-category/",
  contact: "v1/public/contact/",
  product_home: "v3/public/product/home/",
  product_home_cat: "v3/public/product/home/cat",
  product_by_cat: "v1/public/category/product/",
  product_list_by_cat: "v1/public/category/product/:category_id",
  product_detail: "v1/public/product/detail/", //v2/public/product/detail/:product_id/:product_code,
  product_related: "v2/public/product/related/", //v2/public/product/detail/:product_id/:product_code
  product_related_v3: "v3/public/product/related/", //v3/public/product/related/:product_id
  product_bought_together_v3: "v3/public/product/bought-together/", //v3/public/product/bought-together/:product_id
  product_promotion: "v2/public/product/promotion/", // v2/public/product/promotion/:product_feature_code
  product_check_inventory: "v3/public/product/check_inventory/",
  product_wish: "v2/product/wish/",
  product_wish_v2: "v2/product/wish-v2",
  product_info_to_cart: "v2/public/product/info_to_cart/",
  product_search: "v1/public/product/search-for-web",
  voucher_code: "promotion/voucher_code/{voucher_code}",
  order_promotion: "v2/order/promotion",
  order_submit: "v2/order",
  order_submit_v3: "v3/order",
  order_submit_anonymous_v3: "v3/order_anonymous",
  order_list: "v2/order/",
  order_detail: "v2/order/detail/",
  order_reject: "v2/order/reject/",
  user_signin: "v1/public/login/",
  user_signup: "v1/user/register/",
  user_confirm_otp_code: "v1/user/confirm/",
  user_resend_otp_code: "v1/user/resend_otp/",
  user_signout: "v1/user/logout/",
  user_forgot_password: "v1/user/forgot_password/",
  user_profile: "v1/user/detail/",
  user_avatar: "v1/user/avatar/",
  user_avatar_s3: "v1/user/avatar/s3",
  user_change_password: "v1/user/change_password/",
  user_update_profile: "v1/user/update_user_profile/",
  user_delivery: "v1/user/delivery/",
  user_check: "v1/user/check/",
  user_point_history: "v2/user/point_history/",
  score_game: "v2/user/game/",
  reward_game: "v2/user/reward/",
  warranty: "v1/public/warranty/",
  public_country: "v1/public/country/",
  public_provinces: "v1/public/provinces/",
  public_districts: "v1/public/districts/",
  public_wards: "v1/public/wards/",
  public_notification_device: "v1/public/notification/device/",
  public_notification_count: "v1/public/count/notification/",
  public_notification: "v1/public/notification/",
  public_store: "v1/public/store/",
  public_district_store: "v1/public/district/store/",
  public_filter_store: "v1/public/filter/store/",
  public_filter_options: "v1/public/filter_options/",
  public_filter_option_childs: "v1/public/filter_option_childs/",
  public_game: "v2/public/game/",
  public_event: "v2/public/event/",
  public_search_product: "v2/public/product/search/",
  public_policy: "v2/public/policy/",
  public_anonymous_address: "v2/public/anonymous/address",
  public_check_discount_code: "v2/public/check_discount_code/",
  public_check_present_code: "v2/public/check_present_code/",
  public_user_handbook: "v2/public/user/handbook",
  event_images: "event-images",
  event_image: "event-images/:id",
  event_image_details_home_page: "event-images/details/home-page",
  viettel_payment: "v2/payment/viettelpay/pay",
  payoo_payment: "v2/payment/payoo/pay",
  log_payment_transaction: "v2/payment/log_app_payment_transaction",
  check_revison: "v1/public/check_revison/",
  get_config_deep_links: "v1/public/deep-links",
  recordDynamicLinkReference: "v1/public/record_reference",
  sc_payment_sign_encrypt: "v1/payment/sign-encrypt",
  payoo_verify_transaction: "v1/payment/payoo/verify",
  payment_methods: "/v1/payment/list",
  // payoo_retry_payment: "v1/payment/payoo/retry",
  order_change_payment_method: "v2/order/change-payment-method/",
  payoo_retry_payment: "v2/payment/payoo/retry/pay",
};
